import { useRoute } from '@react-navigation/native';
import React from 'react';
import { ScrollView } from 'react-native';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import { isWeb } from 'src/utils/platform';
import Row from '../../layout/Row';
import TabHeaderItem from './TabHeaderItem';
function TabHeader({ tabs, activeIndex, onChange, flex, style, ...rowProps }) {
    const [{ theme }] = useTheme();
    const route = useRoute();
    const buildTabTo = (tabID) => isWeb
        ? {
            screen: route.name,
            params: { ...route.params, tabID },
        }
        : undefined;
    return (React.createElement(Row, { bg: theme.palette.background.main, role: "navigation", ...rowProps },
        React.createElement(ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false },
            React.createElement(Row, null, tabs.map((tab, index) => (React.createElement(TabHeaderItem, { key: String(tab.id), label: tab.label, count: tab.count, selected: activeIndex === index, to: buildTabTo(tab.id), onPress: () => onChange(index) })))))));
}
export default TabHeader;
